webpackJsonp([1],{

/***/ "+l77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isBusy === true)?_c('div',{staticClass:"text-center small text-dark my-5 pt-5",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align-middle mx-2"}),_vm._v(" "),_c('strong',[_vm._v("Loading...")])],1):_vm._e(),_vm._v(" "),(_vm.isBusy === false)?_c('div',{staticClass:"demo-app",attrs:{"aria-busy":"false"}},[_c('div',{staticClass:"demo-app-top"},[_c('button',{staticClass:"mb-2",on:{"click":_vm.toggleWeekends}},[_vm._v("Toggle weekends")]),_vm._v(" "),_vm._v("\n      Click on a day to add event\n    ")]),_vm._v(" "),_c('FullCalendar',{ref:"fullCalendar",staticClass:"demo-app-calendar",attrs:{"defaultView":"dayGridMonth","header":{
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
    },"plugins":_vm.calendarPlugins,"weekends":_vm.calendarWeekends,"events":_vm.calendarEvents},on:{"dateClick":_vm.handleDateClick}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/2rn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fullcalendar_vue__ = __webpack_require__("l7UG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fullcalendar_daygrid__ = __webpack_require__("uJAD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fullcalendar_timegrid__ = __webpack_require__("U2C2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fullcalendar_interaction__ = __webpack_require__("uX+s");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FullCalendar: __WEBPACK_IMPORTED_MODULE_3__fullcalendar_vue__["a" /* default */] // make the <FullCalendar> tag available
  },
  data: function data() {
    return {
      isBusy: true,
      customers: [],
      calendarPlugins: [// plugins must be defined in the JS
      __WEBPACK_IMPORTED_MODULE_4__fullcalendar_daygrid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__fullcalendar_timegrid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__fullcalendar_interaction__["a" /* default */] // needed for dateClick
      ],
      calendarWeekends: true,
      calendarEvents: [// initial event data
      { title: 'Event Now', start: new Date() }]
    };
  },
  beforeMount: function beforeMount() {
    this.getForsynList();
  },

  methods: {
    toggleWeekends: function toggleWeekends() {
      this.calendarWeekends = !this.calendarWeekends; // update a property
    },
    gotoPast: function gotoPast() {
      var calendarApi = this.$refs.fullCalendar.getApi(); // from the ref="..."
      calendarApi.gotoDate('2019-08-01'); // call a method on the Calendar object
    },
    handleDateClick: function handleDateClick(arg) {
      if (confirm('Would you like to add an event to ' + arg.dateStr + ' ?')) {
        this.calendarEvents.push({ // add new event data
          title: 'New Event',
          start: arg.date,
          allDay: arg.allDay
        });
      }
    },
    getForsynList: function getForsynList() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('customers').get().then(function (resp) {
                  var forsynListCollection = [];
                  resp.forEach(function (doc) {
                    var forsynListData = doc.data();
                    if (forsynListData.dateForsyn !== null && forsynListData.dateForsyn !== '' && forsynListData.dateForsyn !== undefined) {
                      forsynListCollection.push({
                        backgroundColor: 'lightblue',
                        title: 'FÖRSYN: \r\n' + forsynListData.adress,
                        start: forsynListData.dateForsyn
                      });
                    }
                    if (forsynListData.dateDigging !== null && forsynListData.dateDigging !== '' && forsynListData.dateDigging !== undefined) {
                      forsynListCollection.push({
                        backgroundColor: 'lightgreen',
                        title: 'GRÄVNING: \r\n' + forsynListData.adress,
                        start: forsynListData.dateDigging
                      });
                    }
                  });
                  _this.calendarEvents = forsynListCollection;
                  console.log(_this.customers);
                  _this.isBusy = false;
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "2W8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2t7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__("HVh9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4354021a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__("MuLD");
function injectStyle (ssrContext) {
  __webpack_require__("JUat")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4354021a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4354021a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "36GZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BackToTop',
  props: {
    text: {
      type: String,
      default: 'Voltar ao topo'
    },
    visibleoffset: {
      type: [String, Number],
      default: 600
    },
    visibleoffsetbottom: {
      type: [String, Number],
      default: 0
    },
    right: {
      type: String,
      default: '30px'
    },
    bottom: {
      type: String,
      default: '40px'
    },
    scrollFn: {
      type: Function,
      default: function _default(eventObject) {}
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    window.smoothscroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.addEventListener('scroll', this.catchScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.catchScroll);
  },

  methods: {
    /**
     * Catch window scroll event 
     * @return {void}
     */
    catchScroll: function catchScroll() {
      var pastTopOffset = window.pageYOffset > parseInt(this.visibleoffset);
      var pastBottomOffset = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - parseInt(this.visibleoffsetbottom);
      this.visible = parseInt(this.visibleoffsetbottom) > 0 ? pastTopOffset && !pastBottomOffset : pastTopOffset;
      this.scrollFn(this);
    },

    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop: function backToTop() {
      window.smoothscroll();
      this.$emit('scrolled');
    }
  }
});

/***/ }),

/***/ "3nNc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4cUg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forsynlist_vue__ = __webpack_require__("rJ/N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3a92e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forsynlist_vue__ = __webpack_require__("OaZz");
function injectStyle (ssrContext) {
  __webpack_require__("5wue")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e3a92e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forsynlist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3a92e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forsynlist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4dXn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5wue":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6CWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Badge_vue__ = __webpack_require__("RkRv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd7910e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Badge_vue__ = __webpack_require__("UbbA");
function injectStyle (ssrContext) {
  __webpack_require__("fdv8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bd7910e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Badge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd7910e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Badge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "6Fkd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gallery__ = __webpack_require__("I4KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow__ = __webpack_require__("9Zon");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_single_select__ = __webpack_require__("6EBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_backtotop__ = __webpack_require__("vJRe");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* Input box - upload img
 https://codepen.io/tahazsh/pen/KrYwQb?source=post_page
* https://levelup.gitconnected.com/how-to-preview-images-before-uploading-them-in-vue-4964803adb64*/








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "forsyn",
  components: {
    'gallery': __WEBPACK_IMPORTED_MODULE_5_vue_gallery___default.a,
    VueGallerySlideshow: __WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow___default.a,
    VueSingleSelect: __WEBPACK_IMPORTED_MODULE_7_vue_single_select__["a" /* default */],
    BackToTop: __WEBPACK_IMPORTED_MODULE_8_vue_backtotop__["a" /* default */]
  },

  data: function data() {
    return {
      isBusy: true,
      alert: false,
      imgAlert: false,
      createdAt: new Date(),
      msg: String,
      imageFile: null,
      imgCategory: '',
      imgCategories: ["Före", "Försyn", "Grävning", "Efter", "Övrigt"],
      timeForsyn: 'Not Defined',
      timeDigging: 'Not Defined',
      tForsyn: ['9-11', '12-14', 'Not Defined'],
      tDigging: ['9-11', '12-14', 'Not Defined'],
      dateDigging: 'Not Defined',
      dateForsyn: 'Not Defined',
      choices: [{ value: "forsyn", text: "Försyn" }, { value: "before", text: "Före" }, { value: "digging", text: "Grävning" }, { value: "after", text: "Efter" }, { value: "other", text: "Övrigt" }],
      choiceId: '',
      name: '',
      adress: '',
      postnr: '',
      ort: '',
      fastBet: '',
      email: '',
      color: '',
      phone: '',
      fk: false,
      ttt: false,
      dthv: false,
      fthv: false,
      invoiced: false,
      lawnmover_checked: false,
      water_checked: false,
      owncable_checked: false,
      customerComments: null,
      cable_colors: [{ text: 'Välj färg på duct', value: null }, 'VI', 'BL', 'BR', 'GR', 'VL', 'GRÅ', 'RO', 'RÖ', 'SV', 'TU', 'OR', 'GU'],
      customers: [],
      images_forsyn: [],
      images_forsyn_index: null,
      images_before: [],
      images_before_index: null,
      images_after: [],
      images_after_index: null,
      images_digging: [],
      images_digging_index: null,
      images_other: [],
      images_other_index: null,
      image: '',
      imageUrl: '',
      imageData: '', // we will store base64 format of image in this string
      images: [],
      index: null,
      saveImages: [],
      choiceText: '',
      noImages: null,
      lon: 'Not Defined',
      lat: 'Not Defined',
      items: [],
      key: '',
      fileImg: '',
      fileName: ''
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.isBusy = true;
              _context.next = 3;
              return _this.getForsynIDAndSetForsynID();

            case 3:
              _context.next = 5;
              return _this.firestore();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    firestore: function firestore() {
      return {
        customers: __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection('customers'),
        customer_images: __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection('customers_images')
      };
    },


    /* Sparar ID i vuex  */
    getForsynIDAndSetForsynID: function getForsynIDAndSetForsynID() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.setForsynID(_this2.$route.params.id);

              case 2:
                _context2.next = 4;
                return _this2.getForsynID();

              case 4:
                _context2.next = 6;
                return _this2.getForsynData(_this2.$route.params.id);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    /* Om det finns ID, Radera tidigare ID och Spara nytt ID globalt i Vuex */
    setForsynID: function setForsynID(forsynID) {
      if (forsynID !== undefined && forsynID !== null && forsynID !== '') {
        this.deleteForsynID();
        this.$store.commit('ADD_TO_ID', forsynID);
      } else {
        console.log('ID is undefined, null or empty ');
      }
    },
    getForsynID: function getForsynID() {
      // Hämtar ID ifrån store getters
      return this.$store.getters.forsynID;
    },
    deleteForsynID: function deleteForsynID(ID) {
      /* Tar bort sparade ID */
      this.$store.commit('DELETE_ID', ID);
    },


    /* If it´s possible to retrieve current geo location, get showLocation */
    getLocation: function getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showLocation);
      } else {
        this.error = "Geolocation is not supported.";
      }
    },

    /* Retrieving geo current location and display current coordinates */
    showLocation: function showLocation(position) {
      var lat = this.lat = position.coords.latitude;
      var lon = this.lon = position.coords.longitude;
      //this.setMap(lat, lon);
    },

    getText: function getText() {
      var values = this.choices.map(function (o) {
        return o.value;
      });
      var index = values.indexOf(this.imgCategory);
      this.saveNewImages(this.choiceText = this.choices[index].value);
    },
    saveNewImages: function saveNewImages(images) {
      this.saveImages.push(this.images);
    },
    chooseImage: function chooseImage() {
      this.$refs.fileInput.click();
    },
    onSelectFile: function onSelectFile($event, imgCategory) {
      var _this3 = this;

      var input = this.$refs.fileInput;
      var files = input.files;
      if (files && files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this3.imageData = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit('input', files[0]);
        this.onFilePicked($event, imgCategory);
      }
    },
    onFilePicked: function onFilePicked($event, imgCategory) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var files, filename, fileImg;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(imgCategory === '' || imgCategory === undefined && false)) {
                  _context3.next = 5;
                  break;
                }

                alert('Välj bild kategori');
                console.log('Välj bild kategori');
                _context3.next = 12;
                break;

              case 5:
                _context3.next = 7;
                return $event.target.files;

              case 7:
                // Hämta bilden och invänta tills det är klart.
                files = $event.target.files;
                filename = files[0].name; // Hämta bild namnet

                fileImg = files[0]; // Hämta bilden

                _context3.next = 12;
                return _this4.upDateImgURL(filename, fileImg);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    upDateImgURL: function upDateImgURL(filename, fileImg) {
      var _this5 = this;

      var auth = __WEBPACK_IMPORTED_MODULE_3__main__["fbapp"].auth().currentUser.uid; // Hämtar firebase ID
      var userID = this.getForsynID()[0]; // Hämtar user ID ifrån state

      var imgStorage = 'customers_images/';
      var imgFolder = 'customers_images_';

      __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection(imgFolder + userID).add({ // Uppdatera i firebase med folder och userID
        forsynID: auth, // Spara bilden med firebase AUTH
        imageUrl: this.imageUrl, // Spara bilden med image URL
        imageType: this.imgCategory, // Spara bilden med  categori
        dateTime: new Date() // Spara bilden med  dagens datum och tid
      }).then(function (data) {
        _this5.key = data.id; // Spara firebase ID
        return __WEBPACK_IMPORTED_MODULE_3__main__["fbapp"].storage().ref(imgStorage + _this5.key + filename).put(fileImg);
      }).catch(function (error) {
        console.log(error);
      }).then(function (fileData) {
        return fileData.ref.getDownloadURL();
      }).catch(function (error) {
        console.log(error);
      }).then(function (imageUrl) {
        _this5.imageUrl = imageUrl;
        __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection(imgFolder + userID).doc(_this5.key).update({
          imageUrl: imageUrl
        });
        _this5.imgAlert = true; // Show img alert
      }).catch(function (error) {
        console.log(error);
      });
      setTimeout(function () {
        // Hide alert after sec
        _this5.imgAlert = false;
      }, 3000);
    },
    getForsynData: function getForsynData(forsynID) {
      var _this6 = this;

      this.isBusy = true;
      var docRef = __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection('customers').doc(forsynID).get().then(function (doc) {
        var docData = doc.data();
        _this6.name = docData.name;
        _this6.adress = docData.adress;
        _this6.postnr = docData.postnr;
        _this6.ort = docData.ort;
        _this6.email = docData.email;
        _this6.color = docData.color;
        _this6.phone = docData.phone;
        _this6.fastBet = docData.fastBet;
        _this6.fk = docData.fk;
        _this6.ttt = docData.ttt;
        _this6.dthv = docData.dthv;
        _this6.fthv = docData.fthv;
        _this6.invoiced = docData.invoiced;
        _this6.lawnmover_checked = docData.lawnmover_checked;
        _this6.water_checked = docData.water_checked;
        _this6.owncable_checked = docData.owncable_checked;
        _this6.customerComments = docData.customerComments;
        _this6.dateForsyn = docData.dateForsyn;
        _this6.dateDigging = docData.dateDigging;
        _this6.timeForsyn = docData.timeForsyn;
        _this6.timeDigging = docData.timeDigging;
        _this6.lon = docData.lon;
        _this6.lat = docData.lat;
      }).then(function (resp) {
        var imagesRef = __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection("customers_images_" + _this6.getForsynID()[0]).get().then(function (images) {
          var data = images.docs.map(function (doc) {
            return doc.data();
          });
          data.forEach(function (doc) {
            switch (doc.imageType) {
              case "before":
                this.images_before.push(doc.imageUrl);
                break;
              case "after":
                this.images_after.push(doc.imageUrl);
                break;
              case "forsyn":
                this.images_forsyn.push(doc.imageUrl);
                break;
              case "digging":
                this.images_digging.push(doc.imageUrl);
                break;
              case "other":
                this.images_other.push(doc.imageUrl);
                break;
              default:
                this.images_other.push(doc.imageUrl);
            }
          }.bind(_this6));
          _this6.isBusy = false;
        });
      });
    },
    getStorage: function getStorage() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_firebase__["storage"]);

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    getStringID: function getStringID() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getForsynID());
    },
    updateCustomer: function updateCustomer() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var i;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this8.isBusy = true;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection('customers').get().then(function (resp) {
                  var forsynListCollection = [];
                  resp.forEach(function (doc) {
                    var forsynListData = doc.data();
                    forsynListCollection.push({
                      'id': doc.id
                    });
                  });
                  _this8.items = forsynListCollection;
                });

              case 3:
                for (i = 0; i < _this8.items.length; i++) {
                  console.log(_this8.items[i++].id);
                  /*          await db.collection('customers').doc(this.items[i]).update({
                              lat: '0',
                              lon: '0',
                              dateForsyn: '',
                              timeForsyn: 'Not Defined',
                              dateDigging: '',
                              timeDigging: 'Not Defined',
                            }).then(function () {
                              console.log("Document successfully updated!");
                            }).catch(function (error) {
                              console.error("Error removing document: ", error);
                            });*/
                  //await this.$router.replace('/forsyn-list')
                }

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    setInputData: function setInputData(name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments, dateDigging, dateForsyn, timeDigging, timeForsyn, lon, lat) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:

                console.log('SetinputData: ' + name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments, dateDigging, dateForsyn, timeDigging, timeForsyn, lon, lat);

                if (dateDigging === '') {
                  dateDigging = null;
                }
                if (dateForsyn === '') {
                  dateForsyn = null;
                }
                if (timeDigging === '') {
                  timeDigging = null;
                }
                if (timeForsyn === '') {
                  timeForsyn = null;
                }

                _context6.next = 7;
                return _this9.addNewForsyn(name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments, dateForsyn, dateDigging, timeDigging, timeForsyn, lon, lat);

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    addNewForsyn: function addNewForsyn(name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments, dateForsyn, dateDigging, timeDigging, timeForsyn, lon, lat) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var ID;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                ID = _this10.getForsynID()[0];
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection('customers').doc(ID).update({
                  name: name, adress: adress, postnr: postnr, ort: ort, fastBet: fastBet, email: email,
                  color: color, phone: phone, fk: fk, ttt: ttt, dthv: dthv, fthv: fthv, invoiced: invoiced,
                  lawnmover_checked: lawnmover_checked, water_checked: water_checked, owncable_checked: owncable_checked, customerComments: customerComments,
                  dateForsyn: dateForsyn, dateDigging: dateDigging, timeDigging: timeDigging, timeForsyn: timeForsyn, lon: lon, lat: lat
                }).catch(function (error) {
                  console.error("Error writing document: ", error);
                  alert("Error writing document, try again");
                });

              case 3:
                _this10.showAlert(); // Show alert

                _context7.next = 6;
                return setTimeout(function () {
                  // Hide alert after 3 sec
                  _this10.hideAlert();
                }, 3000);

              case 6:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    showAlert: function showAlert() {
      this.alert = true;
    },
    hideAlert: function hideAlert() {
      this.alert = false;
    },
    showimgAlert: function showimgAlert() {
      this.imgAlert = true;
    },
    hideimgAlert: function hideimgAlert() {
      this.imgAlert = false;
    },


    /* Raderar en försyn */
    deleteForsyn: function deleteForsyn() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var ID;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                ID = _this11.getForsynID()[0];
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection('customers').doc(ID).delete();

              case 3:
                _context8.next = 5;
                return _this11.$router.replace('/forsyn-list');

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },


    /* Raderar alla bilder */
    deleteImgs: function deleteImgs() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var ID;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                ID = _this12.getForsynID()[0];
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection('customers_images_' + ID).delete();

              case 3:
                _context9.next = 5;
                return _this12.$router.replace('/forsyn-list');

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    }
  }
});

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.396c03d.png";

/***/ }),

/***/ "8D1Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vue2LeafletGeosearch_vue__ = __webpack_require__("rtz5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7ed5c192_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vue2LeafletGeosearch_vue__ = __webpack_require__("2W8t");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vue2LeafletGeosearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7ed5c192_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vue2LeafletGeosearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8o8Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BXNR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D//U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('h1',[_vm._v(" Logga in ")]),_vm._v(" "),_c('label',[_c('b-form-input',{staticClass:"loginInput",attrs:{"type":"text","placeholder":"Email","autofocus":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('label',[_c('b-form-input',{staticClass:"loginInput",attrs:{"type":"password","placeholder":"Password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('b-alert',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"mt-5",attrs:{"show":"","variant":"danger"}},[_vm._v(" Felaktig inloggning ")]),_vm._v(" "),_c('b-button',{staticClass:"turqouse",on:{"click":_vm.login}},[_vm._v("Logga in")]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("Har du inget konto ? "),_c('br'),_vm._v(" "),_c('router-link',{staticClass:"a",attrs:{"to":"/sign-up"}},[_vm._v("Skapa konto")])],1),_vm._v(" "),_c('hr',{staticClass:"my-4"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E/Wt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__ = __webpack_require__("36GZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_386676da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__ = __webpack_require__("IMHH");
function injectStyle (ssrContext) {
  __webpack_require__("YS+f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_386676da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EYnv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FBzZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__("fY6B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d970f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__("vafC");
function injectStyle (ssrContext) {
  __webpack_require__("WSTk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61d970f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d970f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Header',
    components: {},
    data: function data() {
        return {
            showNavbar: true,
            lastScrollPosition: 0,
            images: {
                sample: __webpack_require__("7Otq")
            }
        };
    },

    computed: {
        user: function user() {
            return this.$store.getters.getUser;
        }
    },

    mounted: function mounted() {
        window.addEventListener('scroll', this.onScroll);
    },
    beforeDestroy: function beforeDestroy() {
        /* Navbar försvinner vid scroll */
        window.removeEventListener('scroll', this.onScroll);
    },


    methods: {
        /*  async logout() {      // Fungerar också. Ett annat sätt att skriva logout på.
                await firebase.auth().signOut().then(function () {
                    console.log('Signed Out');  });
                await this.$router.replace('/')
            },*/

        signOut: function signOut() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function () {
                console.log('Signed Out');
                _this.$router.replace('/');
            });
        },
        //https://medium.com/@Taha_Shashtari/hide-navbar-on-scroll-down-in-vue-fb85acbdddfe
        onScroll: function onScroll() {
            // Get the current scroll position
            var currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
            if (currentScrollPosition < 0) {
                return;
            }
            // Stop executing this function if the difference between
            // current scroll position and last scroll position is less than some offset
            if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
                return;
            }
            // Here we determine whether we need to show or hide the navbar
            this.showNavbar = currentScrollPosition < this.lastScrollPosition;
            // Set the current scroll position as the last scroll position
            this.lastScrollPosition = currentScrollPosition;
        }
    }

});

/***/ }),

/***/ "HVh9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_login_scss__ = __webpack_require__("byNj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_login_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__css_login_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 //eget stylesheet  för login och sign-up

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signUp',
  components: {},
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  methods: {
    signUp: function signUp() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().createUserWithEmailAndPassword(this.email, this.password).then(function (user) {
        _this.$router.replace('home');
      }, function (err) {
        alert('Oops. ' + err.message);
      });
    }
  }
});

/***/ }),

/***/ "IMHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"back-to-top-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"vue-back-to-top",style:(("bottom:" + (this.bottom) + ";right:" + (this.right) + ";")),on:{"click":_vm.backToTop}},[_vm._t("default",[_c('div',{staticClass:"default"},[_c('span',[_vm._v("\n          "+_vm._s(_vm.text)+"\n        ")])])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JUat":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K4gw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LXZ5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35bc2965_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("pznX");
function injectStyle (ssrContext) {
  __webpack_require__("jD//")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35bc2965_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MMud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MuLD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('h1',[_vm._v(" New account ")]),_vm._v(" "),_c('p',[_vm._v("Let's create a new account!")]),_vm._v(" "),_c('label',[_c('b-form-input',{staticClass:"loginInput",attrs:{"type":"text","placeholder":"Email","autofocus":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('label',[_c('b-form-input',{staticClass:"loginInput",attrs:{"type":"password","placeholder":"Password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-alert',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"mt-5",attrs:{"show":"","variant":"danger"}},[_vm._v(" Felaktig inloggning ")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-button',{staticClass:"belizeBlue",on:{"click":_vm.signUp}},[_vm._v("Sign Up")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"message"},[_vm._v("or go back to "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("login")])],1),_vm._v(" "),_c('hr',{staticClass:"my-4"})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NE+U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"header navbar",class:{ 'navbar--hidden': !_vm.showNavbar },attrs:{"id":"headerNoShow"}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.images.sample,"alt":""}}),_vm._v(" "),_c('input',{staticClass:"menu-btn",attrs:{"type":"checkbox","id":"menu-btn"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"menu",attrs:{"id":"menu"}},[(!_vm.user)?_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/forsyn-list"}},[_vm._v("Hälsö")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/calendar"}},[_vm._v("Kalender")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/map"}},[_vm._v("Karta")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/about"}},[_vm._v("Om företaget")])],1),_vm._v(" "),_c('li',[_c('button',{staticClass:"btn logout",on:{"click":function($event){return _vm.signOut()}}},[_vm._v("Logga ut")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"menu-icon",attrs:{"for":"menu-btn"}},[_c('span',{staticClass:"navicon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fbapp", function() { return fbapp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_firestore__ = __webpack_require__("881v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader__ = __webpack_require__("Lm1b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__ = __webpack_require__("Zo/n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ic_firebase_uploader_dist_ic_firebase_uploader_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_ic_firebase_uploader_dist_ic_firebase_uploader_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_leaflet_dist_leaflet_css__ = __webpack_require__("EYnv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_leaflet_dist_leaflet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_leaflet_dist_leaflet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_single_select__ = __webpack_require__("6EBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_flatpickr_component__ = __webpack_require__("B+20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_flatpickr_dist_flatpickr_css__ = __webpack_require__("K4gw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_flatpickr_dist_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__css_leafletSearch_scss__ = __webpack_require__("BXNR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__css_leafletSearch_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__css_leafletSearch_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__css_leaflet_scss__ = __webpack_require__("yP79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__css_leaflet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__css_leaflet_scss__);














delete __WEBPACK_IMPORTED_MODULE_11_leaflet__["Icon"].Default.prototype._getIconUrl;

__WEBPACK_IMPORTED_MODULE_11_leaflet__["Icon"].Default.mergeOptions({
  iconRetinaUrl: __webpack_require__("LXZ5"),
  iconUrl: __webpack_require__("gMkZ"),
  shadowUrl: __webpack_require__("wkq0")
});







 /* Input Search field */
 /* Map styling, zoom osv */

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_flatpickr_component___default.a, __WEBPACK_IMPORTED_MODULE_13_vue_single_select__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */], __webpack_require__("8AgW"));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ic-firebase-uploader', __WEBPACK_IMPORTED_MODULE_9_ic_firebase_uploader___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('customer-color-badge', {
  props: ['colorname'],
  template: '' + '<div v-if="colorname === \'VI\'">' + '<b-badge class="custom-bg-vi">VI</b-badge></div>' + '<div v-else-if="colorname === \'BL\'"><b-badge class="custom-bg-bl">BL</b-badge></div>' + '<div v-else-if="colorname === \'BR\'"><b-badge class="custom-bg-br">BR</b-badge></div>' + '<div v-else-if="colorname === \'GR\'"><b-badge class="custom-bg-gr">GR</b-badge></div>' + '<div v-else-if="colorname === \'SV\'"><b-badge class="custom-bg-black">SV</b-badge></div>' + '<div v-else-if="colorname === \'GRÅ\'"><b-badge class="custom-bg-grey">GRÅ</b-badge></div>' + '<div v-else-if="colorname === \'OR\'"><b-badge class="custom-bg-or">OR</b-badge></div>' + '<div v-else-if="colorname === \'RÖ\'"><b-badge class="custom-bg-red">RÖ</b-badge></div>' + '<div v-else-if="colorname === \'VL\'"><b-badge class="custom-bg-vl">VL</b-badge></div>' + '<div v-else-if="colorname === \'RO\'"><b-badge class="custom-bg-pink">RO</b-badge></div>' + '<div v-else-if="colorname === \'TU\'"><b-badge class="custom-bg-tu">TU</b-badge></div>' + '<div v-else-if="colorname === \'GU\'"><b-badge class="custom-bg-gu">GU</b-badge></div>'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var config = {
  apiKey: "AIzaSyBZ7eLPJxnm_ACSB8oT-JjT2CltlDsBKE4",
  authDomain: "forsynsweden.firebaseapp.com",
  databaseURL: "https://forsynsweden.firebaseio.com",
  projectId: "forsynsweden",
  storageBucket: "forsynsweden.appspot.com",
  messagingSenderId: "303535351778",
  appId: "1:303535351778:web:12e3dad9183caa65"
};

var firebaseApp = __WEBPACK_IMPORTED_MODULE_7_firebase_app___default.a.initializeApp(config);
firebaseApp.firestore().settings({});
var db = __WEBPACK_IMPORTED_MODULE_7_firebase_app___default.a.firestore();
var fbapp = firebaseApp;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NReb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forsyn_vue__ = __webpack_require__("6Fkd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1deefb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forsyn_vue__ = __webpack_require__("w2r/");
function injectStyle (ssrContext) {
  __webpack_require__("bXmY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e1deefb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forsyn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1deefb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forsyn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NtoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_login_scss__ = __webpack_require__("byNj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_login_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_login_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 //eget stylesheet för login och sign-up


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  components: {},
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().signInWithEmailAndPassword(_this.email, _this.password).then(function (user) {
                  _this.$router.replace('forsyn-list');
                }, function (err) {
                  alert('Oops. ' + err.message);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "OaZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forsynlistContainer"},[(_vm.isBusy === true)?_c('div',{staticClass:"text-center small text-dark my-5 pt-5",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align-middle mx-2"}),_vm._v(" "),_c('strong',[_vm._v("Loading...")])],1):_vm._e(),_vm._v(" "),(_vm.isBusy === false)?_c('b-table',{attrs:{"items":_vm.items,"sort-compare-locale":"sv","aria-busy":"false","sort-by":_vm.sortBy,"sort-desc":_vm.isDescending,"hover":"","small":"","fields":_vm.fields,"tbody-tr-class":_vm.rowClass},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sort-by":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.isDescending=$event},"update:sort-desc":function($event){_vm.isDescending=$event}},scopedSlots:_vm._u([{key:"Details",fn:function(data){return _c('div',{staticClass:"tableHeader btnContainer"},[_c('b-button',{staticClass:"btn-visa-forsyn greenSea",attrs:{"href":("#/forsyn/" + (data.item.id))}},[_vm._v("\n                Info\n            ")])],1)}},{key:"name",fn:function(data){return _c('div',{staticClass:"tableHeader"},[_c('p',[_vm._v(_vm._s(data.item.name))])])}},{key:"phone",fn:function(data){return _c('div',{staticClass:"tableHeader"},[_c('b-button',{staticClass:"btn-visa-phone",attrs:{"href":("tel:" + (data.item.phone))}},[_c('p',[_vm._v(_vm._s(data.item.phone))])])],1)}},{key:"adress",fn:function(data){return _c('div',{staticClass:"tableHeader"},[_c('p',[_vm._v(_vm._s(data.item.adress))])])}},{key:"dateForsyn",fn:function(data){return _c('div',{staticClass:"tableHeader"},[_c('p',[_vm._v(_vm._s(data.item.dateForsyn))])])}},{key:"dateDigging",fn:function(data){return _c('div',{staticClass:"tableHeader"},[_c('p',[_vm._v(_vm._s(data.item.dateDigging))])])}},{key:"Status",fn:function(data){return _c('div',{},_vm._l((data.value),function(item){return _c('div',[(item === 'fk')?_c('div',[_c('badge',{staticClass:"badge"},[_c('p',[_vm._v("Förprojektering")])])],1):(item === 'ttt')?_c('div',[_c('badge',{staticClass:"badge"},[_c('p',[_vm._v("Tillträde till tomt")])])],1):(item === 'dthv')?_c('div',[_c('badge',{staticClass:"badge"},[_c('p',[_vm._v("Duktad till husvägg")])])],1):(item === 'fthv')?_c('div',[_c('badge',{staticClass:"badge"},[_vm._v("Fiber till husvägg")])],1):_vm._e()])}),0)}},{key:"customer_color",fn:function(data){return _c('div',{},[_c('customer-color-badge',{attrs:{"colorname":data.value}})],1)}},{key:"FOS",fn:function(data){return _c('div',{},[_vm._v("\n            "+_vm._s(data.value)+"\n        ")])}},{key:"Fosfärg",fn:function(data){return _c('div',{},[_vm._v("\n            "+_vm._s(data.value)+"\n        ")])}}],null,false,729494323)}):_vm._e(),_vm._v(" "),_c('back-to-top',{staticClass:"btn-to-top",attrs:{"text":"Back to top","visibleoffset":"500"}},[_vm._v("Scroll to top")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QYAS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__("bzF4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a23c8bb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__("YgPw");
function injectStyle (ssrContext) {
  __webpack_require__("MMud")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a23c8bb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a23c8bb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qwey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueSingleSelect_vue__ = __webpack_require__("di1u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_cff60de6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueSingleSelect_vue__ = __webpack_require__("mz1x");
function injectStyle (ssrContext) {
  __webpack_require__("bgTZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cff60de6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueSingleSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_cff60de6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueSingleSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RkRv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Badge',

  //scoped variables in this component
  data: function data() {
    return {};
  },


  // observed variables (by function)
  computed: {},

  // functions firing by template
  methods: {},

  // child components this component calls
  components: {},

  // variables passed from parent template
  props: {},

  // Lifecycle hooks
  created: function created() {},
  mounted: function mounted() {},
  updated: function updated() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ "UbbA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[(_vm.colorname === 'VI')?_c('div',[_c('b-badge',{staticClass:"custom-bg-vi"},[_vm._v("VI")])],1):(_vm.colorname === 'BL')?_c('div',[_c('b-badge',{staticClass:"custom-bg-bl"},[_vm._v("BL")])],1):(_vm.colorname === 'BR')?_c('div',[_c('b-badge',{staticClass:"custom-bg-br"},[_vm._v("BR")])],1):(_vm.colorname === 'GR')?_c('div',[_c('b-badge',{staticClass:"custom-bg-gr"},[_vm._v("GR")])],1):(_vm.colorname === 'SV')?_c('div',[_c('b-badge',{staticClass:"custom-bg-black"},[_vm._v("SV")])],1):(_vm.colorname === 'GRÅ')?_c('div',[_c('b-badge',{staticClass:"custom-bg-grey"},[_vm._v("GRÅ")])],1):(_vm.colorname === 'OR')?_c('div',[_c('b-badge',{staticClass:"custom-bg-or"},[_vm._v("OR")])],1):(_vm.colorname === 'RÖ')?_c('div',[_c('b-badge',{staticClass:"custom-bg-red"},[_vm._v("RÖ")])],1):(_vm.colorname === 'VL')?_c('div',[_c('b-badge',{staticClass:"custom-bg-vl"},[_vm._v("VL")])],1):(_vm.colorname === 'RO')?_c('div',[_c('b-badge',{staticClass:"custom-bg-pink"},[_vm._v("RO")])],1):(_vm.colorname === 'TU')?_c('div',[_c('b-badge',{staticClass:"custom-bg-tu"},[_vm._v("TU")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WSTk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wk/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_gallery__ = __webpack_require__("I4KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gallery_slideshow__ = __webpack_require__("9Zon");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gallery_slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_gallery_slideshow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_single_select__ = __webpack_require__("6EBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jspdf__ = __webpack_require__("l9mu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2canvas__ = __webpack_require__("2Pnh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* Input box - upload img
 https://codepen.io/tahazsh/pen/KrYwQb?source=post_page
* https://levelup.gitconnected.com/how-to-preview-images-before-uploading-them-in-vue-4964803adb64*/











/* harmony default export */ __webpack_exports__["a"] = ({
    name: "forsynPDF",
    components: {
        'gallery': __WEBPACK_IMPORTED_MODULE_3_vue_gallery___default.a,
        VueGallerySlideshow: __WEBPACK_IMPORTED_MODULE_4_vue_gallery_slideshow___default.a,
        VueSingleSelect: __WEBPACK_IMPORTED_MODULE_5_vue_single_select__["a" /* default */],
        moment: __WEBPACK_IMPORTED_MODULE_8_moment__
    },
    beforeMount: function beforeMount() {
        var forsynID = this.$route.params.id;
        this.getForsynData(forsynID);
    },
    data: function data() {
        var _ref;

        return _ref = {
            someDate: null,
            msg: String,
            imageData: null,
            imageFile: null,
            imgCategory: null,
            imgCategories: ["Före", "Försyn", "Grävning", "Efter", "Övrigt"],
            datum_digging: null,
            datum_forsyn: null,
            choices: [{ value: "forsyn", text: "Försyn" }, { value: "before", text: "Före" }, { value: "digging", text: "Grävning" }, { value: "after", text: "Efter" }, { value: "other", text: "Övrigt" }],
            choiceId: '',
            name: '',
            adress: '',
            postnr: '',
            ort: '',
            fastBet: '',
            email: '',
            color: '',
            phone: '',
            fk: false,
            ttt: false,
            dthv: false,
            fthv: false,
            invoiced: false,
            lawnmover_checked: false,
            water_checked: false,
            owncable_checked: false,
            customerComments: '',
            cable_colors: [{ text: 'Välj färg på duct', value: null }, 'VI', 'BL', 'BR', 'GR', 'VL', 'GRÅ', 'RO', 'RÖ', 'SV', 'TU', 'OR', 'GU'],
            customers: [],
            images_forsyn: [],
            images_forsyn_index: null,
            images_before: [],
            images_before_index: null,
            images_after: [],
            images_after_index: null,
            images_digging: [],
            images_digging_index: null,
            images_other: [],
            images_other_index: null,
            image: '',
            image_before: '',
            imageUrl: ''
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'imageData', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'images', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'index', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'saveImages', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'choiceText', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'noImages', null), _ref;
    },
    firestore: function firestore() {
        return {
            customers: __WEBPACK_IMPORTED_MODULE_1__main__["db"].collection('customers').orderBy('createdAt'),
            customer_images: __WEBPACK_IMPORTED_MODULE_1__main__["db"].collection('customers_images'), /* Om inga bilder finns, visa ej. TYVÄRR Fungerar ej */
            if: function _if() {
                var customer_images = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                this.state.noImages = 1;
            }
        };
    },

    computed: {}, /* Hämtar ifrån store getters  */
    methods: {
        downloadWithCSS: function downloadWithCSS() {
            var doc = new __WEBPACK_IMPORTED_MODULE_6_jspdf___default.a();
            /** WITH CSS */
            var canvasElement = document.createElement('canvas');
            __WEBPACK_IMPORTED_MODULE_7_html2canvas___default()(this.$refs.content, { canvas: canvasElement }).then(function (canvas) {
                var img = canvas.toDataURL("image/png");
                doc.addImage(img, 'JPEG', 5, 10);
                doc.save("forsyn.pdf");
            });
            /*        this.$router.replace('/forsyn-list');*/
        },
        download: function download() {
            var doc = new __WEBPACK_IMPORTED_MODULE_6_jspdf___default.a();
            /** WITHOUT CSS */
            var contentHtml = this.$refs.content.innerHTML;
            doc.fromHTML(contentHtml, 15, 15, {
                width: 170
            });
            doc.save("sample.pdf");
        },
        chooseImage: function chooseImage() {
            this.$refs.fileInput.click();
        },
        getText: function getText() {
            var values = this.choices.map(function (o) {
                return o.value;
            });
            var index = values.indexOf(this.selected);
            console.log(this.choiceText = this.choices[index].value);
            this.saveNewImages(this.choiceText = this.choices[index].value);
        },
        saveNewImages: function saveNewImages(images) {
            this.saveImages.push(this.images);
            console.log(this.images);
        },
        onSelectFile: function onSelectFile($event, imgCategory) {
            var _this = this;

            this.onFilePicked($event, imgCategory);
            var input = this.$refs.fileInput;
            var files = input.files;
            if (files && files[0]) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    _this.imageData = e.target.result;
                };
                reader.readAsDataURL(files[0]);
                this.$emit('input', files[0]);
            }
        },
        onFilePicked: function onFilePicked(event, imgCategory) {
            var _this2 = this;

            console.log(+'event + imgCategory ' + event + imgCategory);
            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf('.') <= 0) {
                return alert('Please add a valid file!');
            }
            var fileReader = new FileReader();
            fileReader.addEventListener('load', function () {
                _this2.imageUrl = fileReader.result;
            });
            fileReader.readAsDataURL(files[0]);
            this.image = files[0];

            var imageData = {
                title: this.title,
                creatorId: __WEBPACK_IMPORTED_MODULE_1__main__["fbapp"].auth().currentUser.uid,
                image: this.image,
                forsynid: this.$route.params.id,
                imageType: imgCategory
            };
            /* Här skickar du ett objekt med inmformation om bilden till store för att lagras hos firebase*/
            this.$store.dispatch('createImage', imageData);
        },


        getForsynData: function getForsynData(forsynid) {
            var _this3 = this;

            var docRef = __WEBPACK_IMPORTED_MODULE_1__main__["db"].collection("customers").doc(forsynid).get().then(function (snap) {
                var docData = snap.data();

                _this3.name = docData.name;
                _this3.adress = docData.adress, _this3.postnr = docData.postnr, _this3.ort = docData.ort, _this3.fastBet = docData.fastBet, _this3.email = docData.email, _this3.color = docData.color, _this3.phone = docData.phone, _this3.fk = docData.fk, _this3.ttt = docData.ttt, _this3.dthv = docData.dthv, _this3.fthv = docData.fthv, _this3.invoiced = docData.invoiced, _this3.lawnmover_checked = docData.lawnmover_checked, _this3.water_checked = docData.water_checked, _this3.owncable_checked = docData.owncable_checked, _this3.customerComments = docData.customerComments, _this3.datum_forsyn = docData.datum_forsyn, _this3.datum_digging = docData.datum_digging, _this3.lng = docData.lng, _this3.lat = docData.lat;
            }).then(function (response) {
                var imagesRef = __WEBPACK_IMPORTED_MODULE_1__main__["db"].collection("customers_images_" + forsynid).get().then(function (images) {
                    var data = images.docs.map(function (documentSnapshot) {
                        return documentSnapshot.data();
                    });
                    _this3.downloadWithCSS();
                });
            });
        }, /* Methods - mutation = commit */
        addNewForsyn: function addNewForsyn(name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments, datum_digging, datum_forsyn, lng, lat) {
            var createdAt = new Date();
            console.log(fk);
            __WEBPACK_IMPORTED_MODULE_1__main__["db"].collection('customers').doc(this.$route.params.id).update({ name: name, adress: adress, postnr: postnr, ort: ort, fastBet: fastBet, email: email, color: color, phone: phone, fk: fk, ttt: ttt, dthv: dthv, fthv: fthv, invoiced: invoiced, lawnmover_checked: lawnmover_checked, water_checked: water_checked, owncable_checked: owncable_checked, customerComments: customerComments, createdAt: createdAt, datum_digging: datum_digging, datum_forsyn: datum_forsyn, lng: lng, lat: lat }).catch(function (error) {
                console.error("Error writing document: ", error);
                alert("Error writing document, try again");
            });
            this.$router.replace('/forsyn-list');
        },

        getStorage: function getStorage(e) {
            return __WEBPACK_IMPORTED_MODULE_2_firebase__["storage"];
        }
    }
});

/***/ }),

/***/ "Y88l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YS+f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Login_vue__ = __webpack_require__("lmfZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_SignUp_vue__ = __webpack_require__("2t7q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_about_vue__ = __webpack_require__("FBzZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Map_vue__ = __webpack_require__("QYAS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_forsyn_vue__ = __webpack_require__("NReb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_forsynlist_vue__ = __webpack_require__("4cUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_forsynadd_vue__ = __webpack_require__("hUHF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_forsynPDF_vue__ = __webpack_require__("pHAc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_calendar_vue__ = __webpack_require__("aL60");












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Login_vue__["a" /* default */]
  }, {
    path: '/Sign-up',
    name: 'SignUp',
    component: __WEBPACK_IMPORTED_MODULE_3__views_SignUp_vue__["a" /* default */]
  }, {
    path: '/forsyn-list',
    name: 'forsynlist',
    component: __WEBPACK_IMPORTED_MODULE_7__views_forsynlist_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/forsynadd',
    name: 'Försyn',
    component: __WEBPACK_IMPORTED_MODULE_8__views_forsynadd_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/forsyn/:id',
    name: 'forsyn',
    component: __WEBPACK_IMPORTED_MODULE_6__views_forsyn_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/forsynPDF/:id',
    name: 'forsynPDF',
    component: __WEBPACK_IMPORTED_MODULE_9__views_forsynPDF_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/map',
    name: 'Map',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Map_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/calendar',
    name: 'Kalender',
    component: __WEBPACK_IMPORTED_MODULE_10__views_calendar_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_4__views_about_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }]
}));

/***/ }),

/***/ "YgPw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isBusy === true)?_c('div',{staticClass:"text-center small text-dark my-5 pt-5",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align-middle mx-2"}),_vm._v(" "),_c('strong',[_vm._v("Loading...")])],1):_vm._e(),_vm._v(" "),(_vm.isBusy === false )?_c('div',{staticClass:"mapContainer",attrs:{"aria-busy":"false"}},[_c('div',{staticClass:"gps-icon",on:{"click":function($event){return _vm.getLocation()}}},[_c('span',{staticClass:"small"},[_vm._v("GPS")])]),_vm._v(" "),_c('div',{staticClass:"home-icon",on:{"click":function($event){return _vm.goToList()}}},[_vm._v(" « ")]),_vm._v(" "),_c('div',{staticClass:"map"},[_c('l-map',{attrs:{"zoom":_vm.zoom,"options":_vm.mapOptions,"zoom":_vm.zoom,"center":_vm.center},on:{"update:zoom":[function($event){_vm.zoom=$event},_vm.zoomUpdated],"update:center":_vm.centerUpdated,"update:bounds":_vm.boundsUpdated}},[_c('v-geosearch',{attrs:{"options":_vm.geosearchOptions,"id":"mapSearchContainer"}}),_vm._v(" "),_c('l-control-layers',{attrs:{"position":_vm.layersPosition,"collapsed":false,"sort-layers":true}}),_vm._v(" "),_vm._l((_vm.tileProviders),function(tileProvider){return _c('l-tile-layer',{key:tileProvider.name,attrs:{"name":tileProvider.name,"visible":tileProvider.visible,"url":tileProvider.url,"attribution":tileProvider.attribution,"layer-type":"base"}})}),_vm._v(" "),_c('l-control-zoom',{attrs:{"position":_vm.zoomPosition}}),_vm._v(" "),_c('l-control-attribution',{attrs:{"position":_vm.attributionPosition,"prefix":_vm.attributionPrefix}}),_vm._v(" "),_c('l-control-scale',{attrs:{"imperial":_vm.imperial}}),_vm._v(" "),_c('l-marker',{attrs:{"lat-lng":_vm.center}}),_vm._v(" "),_vm._l((_vm.customers),function(customer){return _c('l-marker',{key:customer.name,attrs:{"clickable":true,"draggable":true,"lat-lng":customer,"icon":customer.icon,"visible":true},on:{"g-click":function($event){_vm.center=_vm.m.center}}},[_c('l-popup',{attrs:{"content":customer.name}})],1)})],2),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('span',[_vm._v("Center: "+_vm._s(_vm.center))]),_c('br'),_vm._v(" "),_c('span',[_vm._v("Zoom: "+_vm._s(_vm.zoom))]),_c('br')])],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zo/n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aL60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_vue__ = __webpack_require__("/2rn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21801628_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_vue__ = __webpack_require__("+l77");
function injectStyle (ssrContext) {
  __webpack_require__("3nNc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21801628_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bXmY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bgTZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bw+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "byNj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bzF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__ = __webpack_require__("iI18");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet_geosearch__ = __webpack_require__("E+XS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet_geosearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_leaflet_geosearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_leaflet_geosearch__ = __webpack_require__("8D1Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_leaflet_dist_components_LCircle__ = __webpack_require__("zJ5A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet_dist_components_LControl__ = __webpack_require__("1Ug+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_leaflet_dist_components_LPolygon__ = __webpack_require__("7A/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_leaflet_dist_components_LIcon__ = __webpack_require__("+v+a");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var tileProviders = [{
    name: "StreetMap",
    visible: true,
    attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
}, {
    name: "OpenToMap",
    visible: false,
    url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
    attribution: 'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
}, {
    name: "Grey Map",
    visible: false,
    url: "http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png",
    attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors'
}];

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Map',
    firestore: function firestore() {
        return {
            customers: __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('customers')
        };
    },

    components: {
        LMap: __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__["a" /* LMap */],
        LTileLayer: __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__["b" /* LTileLayer */],
        LMarker: __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__["c" /* LMarker */],
        LTooltip: __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__["d" /* LTooltip */],
        LPopup: __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__["e" /* LPopup */],
        LControl: __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet_dist_components_LControl__["a" /* default */],
        LIcon: __WEBPACK_IMPORTED_MODULE_10_vue2_leaflet_dist_components_LIcon__["a" /* default */],
        VGeosearch: __WEBPACK_IMPORTED_MODULE_6_vue2_leaflet_geosearch__["a" /* default */],
        LCircle: __WEBPACK_IMPORTED_MODULE_7_vue2_leaflet_dist_components_LCircle__["a" /* default */],
        LPolygon: __WEBPACK_IMPORTED_MODULE_9_vue2_leaflet_dist_components_LPolygon__["a" /* default */],
        LPolyline: __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__["f" /* LPolyline */],
        LLayerGroup: __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__["g" /* LLayerGroup */],
        LControlZoom: __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__["h" /* LControlZoom */],
        LControlAttribution: __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__["i" /* LControlAttribution */],
        LControlScale: __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__["j" /* LControlScale */],
        LControlLayers: __WEBPACK_IMPORTED_MODULE_4_vue2_leaflet__["k" /* LControlLayers */]
    },

    data: function data() {
        return {
            isBusy: true,
            error: '', // If geolocation not is found
            customers: [
            /*name: "Hälsö 1", id: 0, active: false, lng: 11.655, lat: 57.733333, icon: this.defaultIcon},*/
            { name: "Hannas hem 1", lng: 12.114, lat: 57.741 }, { name: "Hannas hem 2", lng: 12.115, lat: 57.742 }, { name: "Hannas hem 3", lng: 12.116, lat: 57.743 }],
            lat: null,
            lon: null,
            bounds: null,
            markers: [],
            items: [],

            mapOptions: {
                zoomControl: false,
                attributionControl: false,
                zoomSnap: true,
                draggable: true
            },

            zoom: 16,
            minZoom: 1,
            maxZoom: 20,
            center: __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.latLng(57.733434, 11.652575), /* kartans default värde */
            zoomPosition: "topleft",
            attributionPosition: "bottomright",
            layersPosition: "topright",
            attributionPrefix: "Vue2Leaflet",
            imperial: false,
            Positions: ["topleft", "topright", "bottomleft", "bottomright"],
            tileProviders: tileProviders,

            geosearchOptions: {
                provider: new __WEBPACK_IMPORTED_MODULE_5_leaflet_geosearch__["OpenStreetMapProvider"]({
                    position: 'topleft',
                    wrapper: 'findbox',
                    markerLocation: true,
                    autoType: false,
                    autoCollapse: true,
                    minLength: 5,
                    showMarker: true,
                    retainZoomLevel: true,
                    showPopup: true,
                    draggable: true,
                    style: 'bar',
                    initial: false,
                    zoom: 11, // set zoom to found location when searched
                    marker: {
                        draggable: true
                    }
                }), //geosearchOptions
                popupFormat: function popupFormat(_ref) {
                    var query = _ref.query,
                        result = _ref.result;
                    return result.label;
                },
                searchLabel: 'Sök adress',
                keepResult: false,
                showMarker: true,
                retainZoomLevel: false,
                initial: false,
                zoom: 11 // set zoom to found location when searched
            }
        };
    },
    beforeCreate: function beforeCreate() {
        //   document.getElementById('headersNoShow').style.display = "none";
        this.isBusy = true;
    },
    beforeMount: function beforeMount() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.getForsynList();

                        case 2:
                            _context.next = 4;
                            return _this.getCustomersCoordinates();

                        case 4:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    mounted: function mounted() {
        /*    Then in you JavaScript you can use mapObject which is Leaflet map instance :
                this.$refs.map.mapObject;*/
        // this.$refs.map.mapObject.setView([57.7335133, 12.130170699999999], 15);
        // this.setMapLocation([57.7335133, 12.130170699999999], 16);
    },


    methods: {
        getForsynList: function getForsynList() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.isBusy = true;
                                _context2.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('customers').get().then(function (resp) {
                                    var forsynListCollection = [];
                                    resp.forEach(function (doc) {
                                        var forsynListData = doc.data();
                                        if (forsynListData.lat.length > 0) {
                                            forsynListCollection.push({
                                                'id': doc.id,
                                                'name': forsynListData.name,
                                                'adress': forsynListData.adress,
                                                'status': Array.isArray(forsynListData.dthv) === true,
                                                _showDetails: false, /* Checkbox*/
                                                'customer_color': forsynListData.color,
                                                'fakturerad': forsynListData.invoiced,
                                                'fastBet': forsynListData.fastBet,
                                                'dateForsyn': forsynListData.dateForsyn,
                                                'timeForsyn': forsynListData.timeForsyn,
                                                'dateDigging': forsynListData.dateDigging,
                                                'timeDigging': forsynListData.timeDigging,
                                                'lat': forsynListData.lat,
                                                'lng': forsynListData.lon,
                                                'Status': [forsynListData.fk, forsynListData.fthv, forsynListData.dthv, forsynListData.ttt]
                                            });
                                        }
                                    });
                                    _this2.customers = forsynListCollection;
                                    _this2.isBusy = false;
                                });

                            case 3:
                                _context2.next = 5;
                                return _this2.getCustomersCoordinates();

                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        goToList: function goToList() {
            this.$router.replace('/forsyn-list');
        },
        centerUpdated: function centerUpdated(center) {
            this.center = center;
        },


        /* Zoom, Center, Bounds gör att iconen flyttar på sig och aktuella koordinater visas */
        zoomUpdated: function zoomUpdated(zoom) {
            this.zoom = zoom;
        },
        boundsUpdated: function boundsUpdated(bounds) {
            this.bounds = bounds;
        },


        /* Sets the map coordinates and locates location on the map */
        setMapLocation: function setMapLocation(lat, lon, zoom) {
            this.$refs.map.mapObject.setView([lon, lat], zoom);
        },

        /* If it´s possible to retrieve current geo location, get showLocation */
        getLocation: function getLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.showLocation);
            } else {
                this.error = "Geolocation is not supported.";
            }
        },

        /* Retrieving geo current location and display current coordinates */
        showLocation: function showLocation(position) {
            var lat = this.lat = position.coords.latitude;
            var lon = this.lon = position.coords.longitude;
            alert('Lat: ' + this.lat + ' Long: ' + this.lon);
        },

        onAdd: function onAdd(e) {
            this.$nextTick(function () {
                return e.target.openPopup();
            });
        },

        getCustomersCoordinates: function getCustomersCoordinates() {
            var getCoords = { getName: '', getLat: '', getLong: '' };

            // console.log('NAME!!! ' + JSON.stringify(this.customers));

            var i = 0;
            while (i <= this.customers) {
                getCoords.getName = this.customers.name;
                getCoords.getLat = this.customers.lat;
                getCoords.getLong = this.customers.lng;
            }
            return getCoords;
        }
    }
});

/***/ }),

/***/ "cjn/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "di1u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pointerScroll__ = __webpack_require__("HNqp");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      required: true
    },
    name: {
      type: String,
      required: false,
      default: function _default() {
        return "";
      }
    },
    options: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    optionLabel: {
      type: String,
      required: false,
      default: function _default() {
        return null;
      }
    },
    optionKey: {
      type: String,
      required: false,
      default: function _default() {
        return null;
      }
    },
    placeholder: {
      type: String,
      required: false,
      default: function _default() {
        return "Search Here";
      }
    },
    maxHeight: {
      type: String,
      default: function _default() {
        return "220px";
      },
      required: false
    },
    inputId: {
      type: String,
      default: function _default() {
        return "single-select";
      },
      required: false
    },
    classes: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          pointer: -1,
          wrapper: "single-select-wrapper",
          input: "search-input",
          icons: "icons",
          required: "required",
          activeClass: "active",
          dropdown: "dropdown"
        };
      }
    },
    initial: {
      type: String,
      required: false,
      default: function _default() {
        return null;
      }
    },
    required: {
      type: Boolean,
      required: false,
      default: function _default() {
        return false;
      }
    },
    maxResults: {
      type: Number,
      required: false,
      default: function _default() {
        return 30;
      }
    },
    tabindex: {
      type: String,
      required: false,
      default: function _default() {
        return "";
      }
    },
    getOptionDescription: {
      type: Function,
      default: function _default(option) {
        if (this.optionKey && this.optionLabel) {
          return option[this.optionKey] + " " + option[this.optionLabel];
        }
        if (this.optionLabel) {
          return option[this.optionLabel];
        }
        if (this.optionKey) {
          return option[this.optionKey];
        }
        return option;
      }
    },
    getOptionValue: {
      type: Function,
      default: function _default(option) {
        if (this.optionKey) {
          return option[this.optionKey];
        }

        if (this.optionLabel) {
          return option[this.optionLabel];
        }

        return option;
      }
    },
    filterBy: {
      type: Function,
      default: function _default(option) {
        if (this.optionLabel && this.optionKey) {
          return option[this.optionLabel].toString().toLowerCase().includes(this.searchText.toString().toLowerCase()) || option[this.optionKey].toString().toLowerCase().includes(this.searchText.toString().toLowerCase());
        }

        if (this.optionLabel) {
          return option[this.optionLabel].toString().toLowerCase().includes(this.searchText.toString().toLowerCase());
        }

        if (this.optionKey) {
          option[this.optionKey].toString().toLowerCase().includes(this.searchText.toString().toLowerCase());
        }

        return option.toString().toLowerCase().includes(this.searchText.toString().toLowerCase());
      }
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__pointerScroll__["a" /* default */]],
  mounted: function mounted() {
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener("keyup", this.handleClickOutside);
    if (this.value && this.options.includes(this.value)) {
      this.selectedOption = this.value;
      return;
    }
    this.searchText = this.initial;
  },
  destroyed: function destroyed() {
    document.removeEventListener("keyup", this.handleClickOutside);
    document.removeEventListener("click", this.handleClickOutside);
  },
  data: function data() {
    return {
      searchText: null,
      selectedOption: null,
      dropdownOpen: false
    };
  },

  watch: {
    value: function value(curr, prev) {
      this.selectedOption = curr;
    },
    searchText: function searchText(curr, prev) {
      if (curr !== prev) {
        this.pointer = -1;
      }
    },
    selectedOption: function selectedOption(curr, prev) {
      this.$emit("input", curr);
    },
    dropdownOpen: function dropdownOpen(curr, prev) {
      var _this = this;

      if (curr === prev) {
        return;
      }

      if (!curr) {
        this.searchText = null;
        return;
      }

      if (!this.searchText) {
        this.searchText = "";
      }

      this.$nextTick().then(function () {
        _this.$refs.search.focus();
      });
    }
  },
  computed: {
    isRequired: function isRequired() {
      if (!this.required) {
        return "";
      }

      if (this.selectedOption) {
        return "";
      }

      return "required";
    },
    matchingOptions: function matchingOptions() {
      var _this2 = this;

      if (this.searchText === null) {
        return null;
      }
      if (!this.searchText.length) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.options)).slice(0, this.maxResults);
      }

      return this.options.filter(function (option) {
        return _this2.filterBy(option);
      }).slice(0, this.maxResults);
    }
  },
  methods: {
    setPointerIdx: function setPointerIdx(idx) {
      this.pointer = idx;
    },
    seedSearchText: function seedSearchText() {
      if (this.searchText !== null) {
        return;
      }

      this.searchText = "";
    },
    switchToSearch: function switchToSearch(event) {
      this.$refs.selectedValue.value = null;
      this.searchText = event.target.value;
      this.selectedOption = null;
      this.dropdownOpen = true;
    },
    toggleDropdown: function toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeOut: function closeOut() {
      this.selectedOption = null;
      this.dropdownOpen = false;
      this.searchText = null;
    },
    movePointerDown: function movePointerDown() {
      if (!this.matchingOptions) {
        return;
      }
      if (this.pointer >= this.matchingOptions.length - 1) {
        return;
      }

      this.pointer++;
    },
    movePointerUp: function movePointerUp() {
      if (this.pointer > 0) {
        this.pointer--;
      }
    },
    setOption: function setOption() {
      var _this3 = this;

      if (!this.matchingOptions || !this.matchingOptions.length) {
        return;
      }
      if (this.pointer === -1) {
        this.pointer++;
      }

      this.selectedOption = this.matchingOptions[this.pointer];
      this.searchText = null;
      this.dropdownOpen = false;
      this.pointer = -1;
      this.$nextTick().then(function () {
        _this3.$refs.match.focus();
      });
    },
    handleClickOutside: function handleClickOutside(e) {
      if (this.$el.contains(e.target)) {
        return;
      }

      this.dropdownOpen = false;
      this.searchText = null;
    }
  }
});

/***/ }),

/***/ "fY6B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about',
  components: {},
  data: function data() {
    return {
      url: 'https://www.facebook.com/fredlundfiber/',
      email: 'Kalle@Fredlund.nu',
      images: {
        img1: __webpack_require__("xKzv"),
        img2: __webpack_require__("l+q9")
      }
    };
  },

  methods: {}
});

/***/ }),

/***/ "fdv8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gMkZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "gfa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content",staticClass:"container"},[_c('div',{staticClass:"flex-grid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"},[_c('span',[_vm._v(" "+_vm._s(_vm._f("moment")(new Date(),"dddd, MMMM Do YYYY"))+" ")])]),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('b-form-input',{model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.postnr ),callback:function ($$v) {_vm.postnr =$$v},expression:"postnr "}}),_vm._v(" "),_c('b-form-input',{attrs:{"type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-form-input',{model:{value:(_vm.adress),callback:function ($$v) {_vm.adress=$$v},expression:"adress"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.ort),callback:function ($$v) {_vm.ort=$$v},expression:"ort"}}),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.fastBet),callback:function ($$v) {_vm.fastBet=$$v},expression:"fastBet"}})],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v(" Kommentarer ")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"placeholder":"Kundkommentarer","rows":"7","max-rows":"20"},model:{value:(_vm.customerComments),callback:function ($$v) {_vm.customerComments=$$v},expression:"customerComments"}})],1),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Försyn")]),_vm._v(" "),_c('flat-pickr',{attrs:{"placeholder":"-"},model:{value:(_vm.datum_forsyn),callback:function ($$v) {_vm.datum_forsyn=$$v},expression:"datum_forsyn"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Markarbete")]),_vm._v(" "),_c('flat-pickr',{attrs:{"placeholder":"-"},model:{value:(_vm.datum_digging),callback:function ($$v) {_vm.datum_digging=$$v},expression:"datum_digging"}})],1),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Försyn")]),_vm._v(" "),_vm._l((_vm.images_forsyn),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_forsyn_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_forsyn,"index":_vm.images_forsyn_index},on:{"close":function($event){_vm.images_forsyn_index = null}}})],2),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Före")]),_vm._v(" "),_vm._l((_vm.images_before),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_before_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_before,"index":_vm.images_before_index},on:{"close":function($event){_vm.images_before_index = null}}})],2)]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Grävning")]),_vm._v(" "),_vm._l((_vm.images_digging),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_digging_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_digging,"index":_vm.images_digging_index},on:{"close":function($event){_vm.images_digging_index = null}}})],2),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Efter ")]),_vm._v(" "),_vm._l((_vm.images_after),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_after_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_after,"index":_vm.images_after_index},on:{"close":function($event){_vm.images_after_index = null}}})],2)]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Övrigt")]),_vm._v(" "),_vm._l((_vm.images_other),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_other_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_other,"index":_vm.images_other_index},on:{"close":function($event){_vm.images_other_index = null}}})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('h4',[_vm._v(" Kund ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hUHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forsynadd_vue__ = __webpack_require__("vgKe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc1c16a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forsynadd_vue__ = __webpack_require__("imk7");
function injectStyle (ssrContext) {
  __webpack_require__("mAmA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc1c16a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forsynadd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc1c16a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forsynadd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "imk7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content",staticClass:"container"},[_c('button',{staticClass:"fixed-top turqouse",on:{"click":function($event){return _vm.getLocation()}}},[_vm._v("Hitta koordinater")]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.setInputData(_vm.name, _vm.adress, _vm.postnr, _vm.ort, _vm.fastBet, _vm.email,
                  _vm.color, _vm.phone, _vm.fk, _vm.ttt, _vm.dthv, _vm.fthv, _vm.invoiced, _vm.lawnmover_checked, _vm.water_checked, _vm.owncable_checked, _vm.customerComments,
                 _vm.dateDigging, _vm.dateForsyn, _vm.timeDigging, _vm.timeForsyn, _vm.lon, _vm.lat)}}},[_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('b-form-group',{attrs:{"label":"Namn"}},[_c('b-form-input',{model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Ort"}},[_c('b-form-input',{model:{value:(_vm.ort),callback:function ($$v) {_vm.ort=$$v},expression:"ort"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"E-post","description":""}},[_c('b-form-input',{attrs:{"type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Fastighetsbet"}},[_c('b-form-input',{model:{value:(_vm.fastBet),callback:function ($$v) {_vm.fastBet=$$v},expression:"fastBet"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"lat"}},[_c('b-form-input',{model:{value:(_vm.lat),callback:function ($$v) {_vm.lat=$$v},expression:"lat"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-form-group',{attrs:{"label":"Adress"}},[_c('b-form-input',{model:{value:(_vm.adress),callback:function ($$v) {_vm.adress=$$v},expression:"adress"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Postnr"}},[_c('b-form-input',{model:{value:(_vm.postnr),callback:function ($$v) {_vm.postnr=$$v},expression:"postnr"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Telefon"}},[_c('b-form-input',{model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Kundfärg:"}},[_c('b-form-select',{staticClass:"rounded-0",attrs:{"options":_vm.cable_colors,"required":""},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"long"}},[_c('b-form-input',{model:{value:(_vm.lon),callback:function ($$v) {_vm.lon=$$v},expression:"lon"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h3',[_vm._v("Status")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"fk","value":"fk","unchecked-value":"fk_not_done"},model:{value:(_vm.fk),callback:function ($$v) {_vm.fk=$$v},expression:"fk"}},[_vm._v(" Förprojektering klar ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"ttt","value":"ttt","unchecked-value":"ttt_not_done"},model:{value:(_vm.ttt),callback:function ($$v) {_vm.ttt=$$v},expression:"ttt"}},[_vm._v(" Tillträde till tomtmar ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"dthv","value":"dthv","unchecked-value":"dthv_not_done"},model:{value:(_vm.dthv),callback:function ($$v) {_vm.dthv=$$v},expression:"dthv"}},[_vm._v(" Duct till Husvägg ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"fthv","value":"fthv","unchecked-value":"fthv_not_done"},model:{value:(_vm.fthv),callback:function ($$v) {_vm.fthv=$$v},expression:"fthv"}},[_vm._v(" Fiber till Husvägg ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"invoiced","value":"invoiced","unchecked-value":"invoiced_not_done"},model:{value:(_vm.invoiced),callback:function ($$v) {_vm.invoiced=$$v},expression:"invoiced"}},[_vm._v(" Fakturerad ")])],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h3',[_vm._v("Övrigt")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"name":"check-button-lawnmover","switch":""},model:{value:(_vm.lawnmover_checked),callback:function ($$v) {_vm.lawnmover_checked=$$v},expression:"lawnmover_checked"}},[_vm._v(" Gräsklipparkabel ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"name":"check-button-water","switch":""},model:{value:(_vm.water_checked),callback:function ($$v) {_vm.water_checked=$$v},expression:"water_checked"}},[_vm._v(" Sommarvattenslang ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"name":"check-button-owncable","switch":""},model:{value:(_vm.owncable_checked),callback:function ($$v) {_vm.owncable_checked=$$v},expression:"owncable_checked"}},[_vm._v(" Belysningskabel eller egen kabel ")])],1)]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('b-form-textarea',{attrs:{"placeholder":"Kundkommentarer","rows":"7","max-rows":"20"},model:{value:(_vm.customerComments),callback:function ($$v) {_vm.customerComments=$$v},expression:"customerComments"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Planerad försyn")]),_vm._v(" "),_c('flat-pickr',{attrs:{"placeholder":"Välj datum"},model:{value:(_vm.dateForsyn),callback:function ($$v) {_vm.dateForsyn=$$v},expression:"dateForsyn"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Önskad tid")]),_vm._v(" "),_c('vue-single-select',{attrs:{"options":_vm.tForsyn,"placeholder":"Sök tid","value":""},model:{value:(_vm.timeForsyn),callback:function ($$v) {_vm.timeForsyn=$$v},expression:"timeForsyn"}})],1),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Planerad grävning")]),_vm._v(" "),_c('flat-pickr',{attrs:{"placeholder":"Välj datum"},model:{value:(_vm.dateDigging),callback:function ($$v) {_vm.dateDigging=$$v},expression:"dateDigging"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Önskad tid")]),_vm._v(" "),_c('vue-single-select',{attrs:{"options":_vm.tDigging,"placeholder":"Sök tid","value":""},model:{value:(_vm.timeDigging),callback:function ($$v) {_vm.timeDigging=$$v},expression:"timeDigging"}})],1),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Välj bildkategori ")]),_vm._v(" "),_c('div',{staticClass:"select-dropdown"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.imgCategory),expression:"imgCategory"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.imgCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getText]}},_vm._l((_vm.choices),function(choice){return _c('option',{domProps:{"value":choice.value}},[_vm._v(_vm._s(choice.text))])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"base-image-input",style:({ 'background-image': ("url(" + _vm.imageData + ")") }),on:{"click":_vm.chooseImage}},[(!_vm.imageData)?_c('span',{staticClass:"placeholder"},[_vm._v("\n              Välj bild\n          ")]):_vm._e(),_vm._v(" "),_c('input',{ref:"fileInput",staticClass:"file-input",attrs:{"type":"file","imagetype":_vm.images_forsyn + _vm.choiceText,"state":Boolean(_vm.images_forsyn),"data-type":_vm.images_forsyn},on:{"input":function($event){return _vm.onSelectFile($event, _vm.choiceText)}}})])]),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('b-button',{staticClass:"button turqouse",attrs:{"type":"submit"}},[_vm._v(" Save ")])],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-button',{staticClass:"button red",attrs:{"type":"reset"},on:{"click":function($event){return _vm.clearForsyn()}}},[_vm._v("Clear")])],1),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Försyn")]),_vm._v(" "),_vm._l((_vm.images_forsyn),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_forsyn_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_forsyn,"index":_vm.images_forsyn_index},on:{"close":function($event){_vm.images_forsyn_index = null}}})],2),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Före")]),_vm._v(" "),_vm._l((_vm.images_before),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_before_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_before,"index":_vm.images_before_index},on:{"close":function($event){_vm.images_before_index = null}}})],2)]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Grävning")]),_vm._v(" "),_vm._l((_vm.images_digging),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_digging_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_digging,"index":_vm.images_digging_index},on:{"close":function($event){_vm.images_digging_index = null}}})],2),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Efter ")]),_vm._v(" "),_vm._l((_vm.images_after),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_after_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_after,"index":_vm.images_after_index},on:{"close":function($event){_vm.images_after_index = null}}})],2)]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Övrigt")]),_vm._v(" "),_vm._l((_vm.images_other),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_other_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_other,"index":_vm.images_other_index},on:{"close":function($event){_vm.images_other_index = null}}})],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jD//":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l+q9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fiber2.6d34fa1.jpg";

/***/ }),

/***/ "lmfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("NtoT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ccaf74e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("D//U");
function injectStyle (ssrContext) {
  __webpack_require__("8o8Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ccaf74e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ccaf74e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mAmA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mz1x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vuesingleselect"},[(!_vm.selectedOption)?_c('div',{class:_vm.classes.wrapper},[_c('div',{staticClass:"relative inline-block w-full"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],ref:"search",class:[_vm.classes.input, _vm.isRequired],attrs:{"id":_vm.inputId,"placeholder":_vm.placeholder,"autocomplete":"off","required":_vm.required},domProps:{"value":(_vm.searchText)},on:{"click":_vm.seedSearchText,"focus":_vm.seedSearchText,"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.setOption($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.movePointerDown($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();return _vm.closeOut($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.stopPropagation();return _vm.closeOut($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.movePointerUp($event)}],"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"cursor-pointer absolute flex items-center",class:[_vm.classes.icons],on:{"click":_vm.toggleDropdown}},[(!_vm.dropdownOpen)?_c('svg',{attrs:{"aria-hidden":"true","viewBox":"0 0 448 512"}},[_c('path',{attrs:{"d":"M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"}})]):_c('svg',{attrs:{"aria-hidden":"true","viewBox":"0 0 448 512"}},[_c('path',{attrs:{"d":"M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"}})])]),_vm._v(" "),(_vm.matchingOptions)?_c('ul',{ref:"options",staticClass:"absolute w-full overflow-auto appearance-none mt-px list-reset",class:[_vm.classes.dropdown],staticStyle:{"z-index":"100"},style:({'max-height': _vm.maxHeight}),attrs:{"tabindex":"-1"}},_vm._l((_vm.matchingOptions),function(option,idx){return _c('li',{key:idx,staticClass:"cursor-pointer outline-none",class:idx === _vm.pointer ? _vm.classes.activeClass : '',attrs:{"tabindex":"-1"},on:{"blur":function($event){return _vm.handleClickOutside($event)},"mouseover":function($event){return _vm.setPointerIdx(idx)},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.setOption()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.movePointerUp()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.movePointerDown()}],"click":function($event){$event.preventDefault();return _vm.setOption()}}},[_vm._t("option",[_vm._v("\n                        "+_vm._s(_vm.getOptionDescription(option))+"\n                    ")],null,{option: option,idx: idx})],2)}),0):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedOption)?_c('div',{class:_vm.classes.wrapper},[_c('input',{ref:"match",class:[_vm.classes.input],attrs:{"id":_vm.inputId,"required":_vm.required},domProps:{"value":_vm.getOptionDescription(_vm.selectedOption)},on:{"input":function($event){return _vm.switchToSearch($event)},"click":function($event){return _vm.switchToSearch($event)}}}),_vm._v(" "),_c('input',{ref:"selectedValue",attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.getOptionValue(_vm.selectedOption)}}),_vm._v(" "),_c('div',{staticClass:"flex absolute items-center",class:_vm.classes.icons},[_c('svg',{staticClass:"cursor-pointer",attrs:{"aria-hidden":"true","viewBox":"0 0 512 512"},on:{"click":_vm.closeOut}},[_c('path',{attrs:{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"}})])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({

  state: function state() {
    return {
      forsynID: [],
      user: null
    };
  },

  mutations: {
    ADD_TO_ID: function ADD_TO_ID(state, ID) {
      this.state.forsynID.push(ID);
    },
    REMOVE_FROM_ID: function REMOVE_FROM_ID(state, item) {
      this.state.forsynID.splice(item, 1);
    },
    DELETE_ID: function DELETE_ID(state) {
      this.state.forsynID = [];
    },

    setUser: function setUser(state) {
      state.user = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser;
    }
  },

  actions: {
    setUser: function setUser(context) {
      context.commit('setUser');
    }
  },

  getters: { /* Getters are helper functions that retrieve data from our state. */
    forsynID: function forsynID(state) {
      return state.forsynID;
    },
    //https://www.freecodecamp.org/news/managing-user-state-with-vuex-firebase-77eebc64f546/ VUEX AUTH DEMO
    getUser: function getUser(state) {
      return state.user; // use it in any of our components by calling this.$store.getters.getUser;
    }
  }
}));

/***/ }),

/***/ "pHAc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forsynPDF_vue__ = __webpack_require__("Wk/K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17808c0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forsynPDF_vue__ = __webpack_require__("gfa9");
function injectStyle (ssrContext) {
  __webpack_require__("Y88l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17808c0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forsynPDF_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17808c0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forsynPDF_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pznX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"divContainer"},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rJ/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Badge__ = __webpack_require__("6CWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_backtotop__ = __webpack_require__("vJRe");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "forsyn",
    components: {
        Badge: __WEBPACK_IMPORTED_MODULE_3__components_Badge__["Badge"],
        BackToTop: __WEBPACK_IMPORTED_MODULE_4_vue_backtotop__["a" /* default */]
    },
    data: function data() {
        return {
            sortBy: 'adress',
            isDescending: false,
            id: this.$route.params.id,
            isBusy: true,
            items: [],
            fields: [{
                key: "Details",
                sortable: false,
                label: "",
                class: ""
            }, {
                key: "name",
                sortable: true,
                label: "Namn"
            }, {
                key: "phone",
                sortable: false,
                label: "Telefon"
            }, {
                key: "adress",
                sortable: true,
                label: "Adress"
            }, {
                key: "customer_color",
                sortable: false,
                label: "Färg"
            }, {
                key: "dateForsyn",
                sortable: true,
                label: "Försyn"
            }, {
                key: "dateDigging",
                sortable: true,
                label: "Gräv"
            }, {
                key: "Status",
                sortable: true,
                label: "Status"
            }]
        };
    },
    firestore: function firestore() {
        return {
            customers: __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('customers').orderBy('adress')
        };
    },
    beforeMount: function beforeMount() {
        this.getForsynList();
    },
    mounted: function mounted() {},
    created: function created() {},


    computed: {}, /* Hämtar ifrån store getters  */
    methods: {
        /* Methods - mutation = commit */
        getForsynList: function getForsynList() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('customers').get().then(function (resp) {
                                    var forsynListCollection = [];
                                    resp.forEach(function (doc) {
                                        var forsynListData = doc.data();
                                        forsynListCollection.push({
                                            'id': doc.id,
                                            'name': forsynListData.name,
                                            'phone': forsynListData.phone,
                                            'adress': forsynListData.adress,
                                            'status': Array.isArray(forsynListData.dthv) === true,
                                            _showDetails: false, /* Checkbox*/
                                            'customer_color': forsynListData.color,
                                            'fakturerad': forsynListData.invoiced,
                                            'fastBet': forsynListData.fastBet,
                                            'dateForsyn': forsynListData.dateForsyn,
                                            'timeForsyn': forsynListData.timeForsyn,
                                            'dateDigging': forsynListData.dateDigging,
                                            'timeDigging': forsynListData.timeDigging,
                                            'lat': forsynListData.lat,
                                            'lon': forsynListData.lon,
                                            'Status': [forsynListData.fk, forsynListData.fthv, forsynListData.dthv, forsynListData.ttt]
                                        });
                                    });
                                    _this.items = forsynListCollection;
                                    _this.isBusy = false;
                                });

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        rowClass: function rowClass(item) {
            if (!item) return;
            if (item.status === true) return 'table-success';
        }
    }
});

/***/ }),

/***/ "rtz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet_geosearch__ = __webpack_require__("E+XS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet_geosearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet_geosearch__);
//
//
//
//
//
//

// import L from 'leaflet';


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    options: {
      required: true
    }
  },
  name: 'v-geosearch',
  mounted: function mounted() {
    this.add();
  },
  beforeDestroy: function beforeDestroy() {
    this.remove();
  },

  methods: {
    deferredMountedTo: function deferredMountedTo(parent) {
      var searchControl = new __WEBPACK_IMPORTED_MODULE_0_leaflet_geosearch__["GeoSearchControl"](this.options);
      parent.addControl(searchControl);
    },
    remove: function remove() {
      if (this.markerCluster) {
        this.$parent.removeLayer(this.markerCluster);
      }
    },
    add: function add() {
      if (this.$parent._isMounted) {
        this.deferredMountedTo(this.$parent.mapObject);
      }
    }
  }
});

/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18308abc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("NE+U");
function injectStyle (ssrContext) {
  __webpack_require__("4dXn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18308abc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18308abc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vafC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"aboutContact"},[_c('h1',[_vm._v("Välkommen!")]),_vm._v(" "),_c('p',[_vm._v("Telefon")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("E-post")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":("mailto:" + _vm.email)}},[_vm._v("Kalle@Fredlund.nu")])]),_vm._v(" "),_c('p',[_vm._v("Företags sida")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":_vm.url}},[_vm._v(" Facebook ")])])]),_vm._v(" "),_c('div',{staticClass:"aboutImg"},[_c('div',{staticClass:"imgBox"},[_c('img',{staticClass:"images",attrs:{"src":_vm.images.img1,"alt":""}}),_vm._v(" "),_c('img',{staticClass:"images",attrs:{"src":_vm.images.img2,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"message"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Logga in")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutInfo"},[_c('h1',[_vm._v(" Om ")]),_vm._v(" "),_c('p',[_vm._v("\n      Fiberentreprenad drivs av Kalle Fredlund.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Med inovation och ny teknik hittar vi en kostnadseffektiv och "),_c('br'),_vm._v("\n      hållbar lösning inom fiberentreprenad\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"tel: +46768-805822"}},[_vm._v("0768 - 80 58 22")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vgKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gallery__ = __webpack_require__("I4KV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow__ = __webpack_require__("9Zon");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_single_select__ = __webpack_require__("6EBc");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "forsynadd",
  components: {
    'gallery': __WEBPACK_IMPORTED_MODULE_5_vue_gallery___default.a,
    VueGallerySlideshow: __WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow___default.a,
    VueSingleSelect: __WEBPACK_IMPORTED_MODULE_7_vue_single_select__["a" /* default */]
  },

  data: function data() {
    return {
      createdAt: new Date(),
      msg: String,
      imageFile: null,
      imgCategory: '',
      imgCategories: ["Före", "Försyn", "Grävning", "Efter", "Övrigt"],
      timeForsyn: '',
      timeDigging: '',
      tForsyn: ['9-11', '12-14'],
      tDigging: ['9-11', '12-14'],
      dateDigging: '',
      dateForsyn: '',
      choices: [{ value: "forsyn", text: "Försyn" }, { value: "before", text: "Före" }, { value: "digging", text: "Grävning" }, { value: "after", text: "Efter" }, { value: "other", text: "Övrigt" }],
      choiceId: '',
      name: '',
      adress: '',
      postnr: '',
      ort: '',
      fastBet: '',
      email: '',
      color: '',
      phone: '',
      fk: false,
      ttt: false,
      dthv: false,
      fthv: false,
      invoiced: false,
      lawnmover_checked: false,
      water_checked: false,
      owncable_checked: false,
      customerComments: '',
      cable_colors: [{ text: 'Välj färg på duct', value: null }, 'VI', 'BL', 'BR', 'GR', 'VL', 'GRÅ', 'RO', 'RÖ', 'SV', 'TU', 'OR', 'GU'],
      customers: [],
      images_forsyn: [],
      images_forsyn_index: null,
      images_before: [],
      images_before_index: null,
      images_after: [],
      images_after_index: null,
      images_digging: [],
      images_digging_index: null,
      images_other: [],
      images_other_index: null,
      image: '',
      image_before: '',
      imageUrl: '',
      imageData: '', // we will store base64 format of image in this string
      images: [],
      index: null,
      saveImages: [],
      choiceText: '',
      noImages: null,
      lon: '',
      lat: '',
      showAlert: false
    };
  },
  beforeMount: function beforeMount() {
    /*   await this.getForsynIDAndSetForsynID();
    await console.log('getForsynID: ' + this.getForsynID());
    await this.firestore();*/

    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  computed: {},
  methods: {
    firestore: function firestore() {
      return {
        customers: __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection('customers').orderBy('createdAt'),
        customer_images: __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection('customers_images')
      };
    },


    /* Async/promise funktion, sätter ID, sparar ID i vuex, hämtar ID ifrån vuex */
    getForsynIDAndSetForsynID: function getForsynIDAndSetForsynID() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return console.log('Försyn ID: ' + _this2.$route.params.id);

              case 2:
                _context2.next = 4;
                return _this2.setForsynID(_this2.$route.params.id);

              case 4:
                _context2.next = 6;
                return _this2.getForsynData(_this2.$route.params.id);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    /* Om det finns ett ID, Radera tidigare ID och Spara nytt ID globalt i Vuex */
    setForsynID: function setForsynID(forsynID) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(forsynID !== undefined && forsynID !== null && forsynID !== '')) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 3;
                return _this3.deleteForsynID();

              case 3:
                _context3.next = 5;
                return _this3.$store.commit('ADD_TO_ID', forsynID);

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.next = 9;
                return console.log('ID is undefined, null or empty ');

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    deleteForsynID: function deleteForsynID(ID) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.$store.commit('DELETE_ID', ID);

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },


    /* If it´s possible to retrieve current geo location, get showLocation */
    getLocation: function getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showLocation);
      } else {
        this.error = "Geolocation is not supported.";
      }
    },

    /* Retrieving geo current location and display current coordinates */
    showLocation: function showLocation(position) {
      var lat = this.lat = position.coords.latitude;
      var lon = this.lon = position.coords.longitude;
      //this.setMap(lat, lon);
    },

    chooseImage: function chooseImage() {
      this.$refs.fileInput.click();
    },
    getText: function getText() {
      var values = this.choices.map(function (o) {
        return o.value;
      });
      var index = values.indexOf(this.imgCategory);
      //  console.log(this.choiceText = this.choices[index].value);
      this.saveNewImages(this.choiceText = this.choices[index].value);
    },
    saveNewImages: function saveNewImages(images) {
      this.saveImages.push(this.images);
    },
    onSelectFile: function onSelectFile($event, imgCategory) {
      var _this5 = this;

      this.onFilePicked($event, imgCategory);
      var input = this.$refs.fileInput;
      var files = input.files;
      if (files && files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this5.imageData = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit('input', files[0]);
      }
    },
    onFilePicked: function onFilePicked(event, imgCategory) {
      var _this6 = this;

      console.log(+'event + imgCategory ' + event + imgCategory);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this6.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
      var imageData = {
        title: this.title,
        creatorId: __WEBPACK_IMPORTED_MODULE_3__main__["fbapp"].auth().currentUser.uid,
        image: this.image,
        forsynID: this.getForsynID()[0],
        imageType: imgCategory
      };
      /* Skickar objekt med info om bilden till store för att lagra hos firebase*/
      this.$store.dispatch('createImage', imageData);
    }
  },

  /* Get firebase storage */
  getStorage: function getStorage() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_firebase__["storage"]);

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this7);
    }))();
  },


  /* Get string ID */
  getStringID: function getStringID() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getForsynID());
  },
  setInputData: function setInputData(name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments, dateDigging, dateForsyn, timeDigging, timeForsyn, lon, lat) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:

              console.log('SetinputData: ' + name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments, dateDigging, dateForsyn, timeDigging, timeForsyn, lon, lat);
              _this8.name = name;
              _this8.adress = adress;
              _this8.postnr = postnr;
              _this8.ort = ort;
              _this8.fastBet = fastBet;
              _this8.email = email;
              _this8.color = color;
              _this8.phone = phone;
              _this8.fk = fk;
              _this8.ttt = ttt;
              _this8.dthv = dthv;
              _this8.fthv = fthv;
              _this8.invoiced = invoiced;
              _this8.lawnmover_checked = lawnmover_checked;
              _this8.water_checked = water_checked;
              _this8.owncable_checked = owncable_checked;
              _this8.customerComments = customerComments;
              _this8.dateForsyn = dateForsyn;
              _this8.dateDigging = dateDigging;
              _this8.timeDigging = timeDigging;
              _this8.timeForsyn = timeForsyn;
              _this8.lon = lon;
              _this8.lat = lat;

              _context6.next = 26;
              return _this8.addNewForsyn(name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments, dateForsyn, dateDigging, timeDigging, timeForsyn, lon, lat);

            case 26:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this8);
    }))();
  },
  addNewForsyn: function addNewForsyn(name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments, dateForsyn, dateDigging, timeDigging, timeForsyn, lon, lat) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__main__["db"].collection('customers').add({
                name: name, adress: adress, postnr: postnr, ort: ort, fastBet: fastBet, email: email, color: color, phone: phone, fk: fk, ttt: ttt, dthv: dthv, fthv: fthv, invoiced: invoiced,
                lawnmover_checked: lawnmover_checked, water_checked: water_checked, owncable_checked: owncable_checked, customerComments: customerComments,
                dateDigging: dateDigging, dateForsyn: dateForsyn, timeDigging: timeDigging, timeForsyn: timeForsyn, lon: lon, lat: lat });

            case 2:
              _context7.next = 4;
              return _this9.$router.replace('/forsyn-list');

            case 4:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this9);
    }))();
  },


  /* Clear fields and update site*/
  clearForsyn: function clearForsyn() {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this10.clearFields();

            case 2:
              _context8.next = 4;
              return _this10.$router.replace('/forsynadd');

            case 4:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this10);
    }))();
  },
  clearFields: function clearFields() {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _this11.name = '';
              _this11.adress = '';
              _this11.postnr = '';
              _this11.ort = '';
              _this11.fastBet = '';
              _this11.email = '';
              _this11.color = '';
              _this11.phone = '';
              _this11.fk = false;
              _this11.ttt = false;
              _this11.dthv = false;
              _this11.fthv = false;
              _this11.invoiced = false;
              _this11.lawnmover_checked = false;
              _this11.water_checked = false;
              _this11.owncable_checked = false;
              _this11.customerComments = '';
              _this11.dateForsyn = '';
              _this11.dateDigging = '';
              _this11.timeDigging = '';
              _this11.timeForsyn = '';
              _this11.lon = '';
              _this11.lat = '';

            case 23:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this11);
    }))();
  }
});

/***/ }),

/***/ "w2r/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content",staticClass:"containerForsyn"},[(_vm.isBusy === true)?_c('div',{staticClass:"text-center small text-dark my-5 pt-5",attrs:{"slot":"table-busy"},slot:"table-busy"},[_c('b-spinner',{staticClass:"align-middle mx-2"}),_vm._v(" "),_c('strong',[_vm._v("Loading...")])],1):_vm._e(),_vm._v(" "),(_vm.isBusy === false)?_c('div',{attrs:{"aria-busy":"false"}},[_c('div',{staticClass:"bookingInfo"},[_vm._v("\n      "+_vm._s(_vm.name)+", "+_vm._s(_vm.adress)+" "),_c('br'),_vm._v("\n      Forsyn "+_vm._s(_vm.dateForsyn)+" kl "+_vm._s(_vm.timeForsyn)+" "),_c('br'),_vm._v("\n      Grävning "+_vm._s(_vm.dateDigging)+" kl "+_vm._s(_vm.timeDigging)+"\n    ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.setInputData(_vm.name, _vm.adress, _vm.postnr, _vm.ort, _vm.fastBet, _vm.email,
                  _vm.color, _vm.phone, _vm.fk, _vm.ttt, _vm.dthv, _vm.fthv, _vm.invoiced, _vm.lawnmover_checked, _vm.water_checked, _vm.owncable_checked, _vm.customerComments,
                 _vm.dateDigging, _vm.dateForsyn, _vm.timeDigging, _vm.timeForsyn, _vm.lon, _vm.lat)}}},[_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('b-form-group',{attrs:{"label":"Namn"}},[_c('b-form-input',{attrs:{"required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Ort"}},[_c('b-form-input',{attrs:{"required":""},model:{value:(_vm.ort),callback:function ($$v) {_vm.ort=$$v},expression:"ort"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"E-post","description":""}},[_c('b-form-input',{attrs:{"type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Fastighetsbet"}},[_c('b-form-input',{attrs:{"required":""},model:{value:(_vm.fastBet),callback:function ($$v) {_vm.fastBet=$$v},expression:"fastBet"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Lat"}},[_c('b-form-input',{model:{value:(_vm.lat),callback:function ($$v) {_vm.lat=$$v},expression:"lat"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-form-group',{attrs:{"label":"Adress"}},[_c('b-form-input',{attrs:{"required":""},model:{value:(_vm.adress),callback:function ($$v) {_vm.adress=$$v},expression:"adress"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Postnr"}},[_c('b-form-input',{attrs:{"required":""},model:{value:(_vm.postnr),callback:function ($$v) {_vm.postnr=$$v},expression:"postnr"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Telefon"}},[_c('b-form-input',{attrs:{"required":""},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Kundfärg:"}},[_c('b-form-select',{staticClass:"rounded-0",attrs:{"options":_vm.cable_colors,"required":""},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Long"}},[_c('b-form-input',{model:{value:(_vm.lon),callback:function ($$v) {_vm.lon=$$v},expression:"lon"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Status")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"fk","value":"fk","unchecked-value":"fk_not_done"},model:{value:(_vm.fk),callback:function ($$v) {_vm.fk=$$v},expression:"fk"}},[_vm._v(" Förprojektering klar ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"ttt","value":"ttt","unchecked-value":"ttt_not_done"},model:{value:(_vm.ttt),callback:function ($$v) {_vm.ttt=$$v},expression:"ttt"}},[_vm._v(" Tillträde till tomtmar ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"dthv","value":"dthv","unchecked-value":"dthv_not_done"},model:{value:(_vm.dthv),callback:function ($$v) {_vm.dthv=$$v},expression:"dthv"}},[_vm._v(" Duct till Husvägg ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"fthv","value":"fthv","unchecked-value":"fthv_not_done"},model:{value:(_vm.fthv),callback:function ($$v) {_vm.fthv=$$v},expression:"fthv"}},[_vm._v(" Fiber till Husvägg ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"invoiced","value":"invoiced","unchecked-value":"invoiced_not_done"},model:{value:(_vm.invoiced),callback:function ($$v) {_vm.invoiced=$$v},expression:"invoiced"}},[_vm._v(" Fakturerad ")]),_vm._v(" "),_c('h4',[_vm._v("Övrigt")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"name":"check-button-lawnmover","switch":""},model:{value:(_vm.lawnmover_checked),callback:function ($$v) {_vm.lawnmover_checked=$$v},expression:"lawnmover_checked"}},[_vm._v(" Gräsklipparkabel ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"name":"check-button-water","switch":""},model:{value:(_vm.water_checked),callback:function ($$v) {_vm.water_checked=$$v},expression:"water_checked"}},[_vm._v(" Sommarvattenslang ")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"name":"check-button-owncable","switch":""},model:{value:(_vm.owncable_checked),callback:function ($$v) {_vm.owncable_checked=$$v},expression:"owncable_checked"}},[_vm._v(" Belysningskabel eller egen kabel ")])],1),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('b-form-group',{attrs:{"label":"Kommentarer"}},[_c('b-form-textarea',{attrs:{"placeholder":"Kundkommentarer","rows":"7","max-rows":"20","autofocus":""},model:{value:(_vm.customerComments),callback:function ($$v) {_vm.customerComments=$$v},expression:"customerComments"}})],1)],1)]),_vm._v(" "),_c('h1',[_c('span',[_vm._v("Tid")])]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Planerad försyn")]),_vm._v(" "),_c('flat-pickr',{attrs:{"placeholder":"Välj datum"},model:{value:(_vm.dateForsyn),callback:function ($$v) {_vm.dateForsyn=$$v},expression:"dateForsyn"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Önskad tid")]),_vm._v(" "),_c('vue-single-select',{attrs:{"options":_vm.tForsyn,"placeholder":"Sök tid","value":""},model:{value:(_vm.timeForsyn),callback:function ($$v) {_vm.timeForsyn=$$v},expression:"timeForsyn"}})],1),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Planerad grävning")]),_vm._v(" "),_c('flat-pickr',{attrs:{"placeholder":"Välj datum"},model:{value:(_vm.dateDigging),callback:function ($$v) {_vm.dateDigging=$$v},expression:"dateDigging"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Önskad tid")]),_vm._v(" "),_c('vue-single-select',{attrs:{"options":_vm.tDigging,"placeholder":"Sök tid","value":""},model:{value:(_vm.timeDigging),callback:function ($$v) {_vm.timeDigging=$$v},expression:"timeDigging"}})],1),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('h1',[_c('span',[_vm._v("Bilder")])]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Välj bildkategori ")]),_vm._v(" "),_c('div',{staticClass:"select-dropdown"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.imgCategory),expression:"imgCategory"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.imgCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getText]}},_vm._l((_vm.choices),function(choice){return _c('option',{domProps:{"value":choice.value}},[_vm._v(_vm._s(choice.text))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"base-image-input",style:({ 'background-image': ("url(" + _vm.imageData + ")") }),on:{"click":_vm.chooseImage}},[(!_vm.imageData)?_c('span',{staticClass:"placeholder"},[_vm._v("\n              Välj bild\n          ")]):_vm._e(),_vm._v(" "),_c('input',{ref:"fileInput",staticClass:"file-input",attrs:{"type":"file"},on:{"change":function($event){return _vm.onSelectFile($event, _vm.choiceText)}}})])]),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[_c('div',{staticClass:"col"}),_vm._v(" "),_c('div',{staticClass:"col"},[(_vm.alert)?_c('div',{staticClass:"alert",attrs:{"role":"alert"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v(" Ärendet är sparat! "),_c('br'),_vm._v("\n              Uppdatera sidan")])]):_vm._e(),_vm._v(" "),(_vm.imgAlert)?_c('div',{staticClass:"alert",attrs:{"role":"alert"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v(" Bilden är sparad! "),_c('br'),_vm._v("\n              Uppdatera sidan")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col"})]),_vm._v(" "),_c('div',{staticClass:"flex-grid buttonGroup"},[_c('b-button',{staticClass:"button greenSea",attrs:{"type":"submit"}},[_vm._v(" Spara ")]),_vm._v(" "),_c('b-button',{staticClass:"button red",attrs:{"type":"reset"},on:{"click":function($event){return _vm.deleteForsyn()}}},[_vm._v("Radera kund")])],1)]),_vm._v(" "),_c('div',{staticClass:"imgContainer"},[_c('div',{staticClass:"flex-grid"},[(_vm.images_forsyn!='')?_c('div',{staticClass:"col"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.images_forsyn),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_forsyn_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_forsyn,"index":_vm.images_forsyn_index},on:{"close":function($event){_vm.images_forsyn_index = null}}})],2):_vm._e(),_vm._v(" "),(_vm.images_before!='')?_c('div',{staticClass:"col"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.images_before),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_before_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_before,"index":_vm.images_before_index},on:{"close":function($event){_vm.images_before_index = null}}})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[(_vm.images_digging!='')?_c('div',{staticClass:"col"},[_vm._m(3),_vm._v(" "),_vm._l((_vm.images_digging),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_digging_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_digging,"index":_vm.images_digging_index},on:{"close":function($event){_vm.images_digging_index = null}}})],2):_vm._e(),_vm._v(" "),(_vm.images_after!='')?_c('div',{staticClass:"col"},[_vm._m(4),_vm._v(" "),_vm._l((_vm.images_after),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_after_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_after,"index":_vm.images_after_index},on:{"close":function($event){_vm.images_after_index = null}}})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex-grid"},[(_vm.images_other!='')?_c('div',{staticClass:"col"},[_vm._m(5),_vm._v(" "),_vm._l((_vm.images_other),function(image,i){return _c('img',{key:i,staticClass:"image",attrs:{"src":image},on:{"click":function($event){_vm.images_other_index = i}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images_other,"index":_vm.images_other_index},on:{"close":function($event){_vm.images_other_index = null}}})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col"})])])],1):_vm._e(),_vm._v(" "),_c('back-to-top',{staticClass:"btn-to-top",attrs:{"text":"Back to top","visibleoffset":"500"}},[_vm._v("Scroll to top")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',[_vm._v("Kund")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',[_vm._v("Försyn")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',[_vm._v("Före")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',[_vm._v("Grävning")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',[_vm._v("Efter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',[_vm._v("Övrigt")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wkq0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_css_colors_scss__ = __webpack_require__("cjn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_css_colors_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__src_css_colors_scss__);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'App',
    components: {
        Header: __WEBPACK_IMPORTED_MODULE_1__src_components_Header__["a" /* default */]
    },
    data: function data() {
        return {};
    },


    methods: {
        currentUser: function currentUser() {
            return __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser;
        },
        setUser: function setUser() {
            this.$store.dispatch('setUser');
        }
    },
    created: function created() {
        // this uses Vuex to check if a user is signed in
        this.setUser();
    }
});

/***/ }),

/***/ "xKzv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fiber.8860792.jpg";

/***/ }),

/***/ "yP79":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.734d4ebf317bf6986398.js